
import { Nutritions } from "@/models/Recipes/Nutritions";
import { round } from "@/utils/Helpers";
import { Component, Prop, Vue } from "vue-property-decorator";
import LockIcon from "./icons/LockIcon.vue";
import { NutrientType } from "@/models/Ingredient/NutrientType";
import VTrialMasker from "@/components/vTrialMasker.vue";

@Component({
  components: {LockIcon, VTrialMasker},
  methods: {
    utilsRound: round
  }
})

export default class vNutritionLabelUS extends Vue {
  @Prop() nutrition!: Nutritions;
  @Prop({ default: true }) showRoundedDv!: boolean;
  @Prop() servingsPerContainer: number;

  // Nutrition Facts Reactive Values

  get calories() {
    return this.getNutrientDelegate(NutrientType.Energy, this.showRoundedDv);
  }

  get fat() {
    return this.getNutrientDelegate(NutrientType.Fat, this.showRoundedDv);
  }

  get fatDv() {
    return this.getNutrientDvDelegate(NutrientType.Fat, this.showRoundedDv);
  }

  get saturatedFat() {
    return this.getNutrientDelegate(NutrientType.SaturatedFattyAcids, this.showRoundedDv);
  }

  get transFat() {
    return this.getNutrientDelegate(NutrientType.TransFattyAcids, this.showRoundedDv);
  }

  get saturatedFatDv() {
    return this.getNutrientDvDelegate(NutrientType.SaturatedFattyAcids, this.showRoundedDv);
  }

  get carbohydrates() {
    return this.getNutrientDelegate(NutrientType.Carbohydrate, this.showRoundedDv);
  }

  get carbohydratesDv(){
    return this.getNutrientDvDelegate(NutrientType.Carbohydrate, this.showRoundedDv);
  }

  get fibre() {
    return this.getNutrientDelegate(NutrientType.Fibre, this.showRoundedDv);
  }

  get fibreDv() {
    return this.getNutrientDvDelegate(NutrientType.Fibre, this.showRoundedDv);
  }

  get sugars() {
    return this.getNutrientDelegate(NutrientType.Sugars, this.showRoundedDv);
  }

  get addedSugarsDv() {
    return this.getNutrientDvDelegate(NutrientType.AddedSugar, this.showRoundedDv);
  }

  get addedSugar(){
    return this.getNutrientDelegate(NutrientType.AddedSugar, this.showRoundedDv);
  }

  get protein() {
    return this.getNutrientDelegate(NutrientType.Protein, this.showRoundedDv);
  }

  get cholesterol() {
    return this.getNutrientDelegate(NutrientType.Cholesterol, this.showRoundedDv);
  }

  get cholesterolDv() {
    return this.getNutrientDvDelegate(NutrientType.Cholesterol, this.showRoundedDv);
  }

  get sodium() {
    return this.getNutrientDelegate(NutrientType.Sodium, this.showRoundedDv);
  }

  get sodiumDv() {
    return this.getNutrientDvDelegate(NutrientType.Sodium, this.showRoundedDv);
  }

  get potassium() {
    return this.getNutrientDelegate(NutrientType.Potassium, this.showRoundedDv);
  }

  get potassiumDv() {
    return this.getNutrientDvDelegate(NutrientType.Potassium, this.showRoundedDv);
  }

  get calcium() {
    return this.getNutrientDelegate(NutrientType.Calcium, this.showRoundedDv);
  }

  get calciumDv() {
    return this.getNutrientDvDelegate(NutrientType.Calcium, this.showRoundedDv);
  }

  get iron() {
    return this.getNutrientDelegate(NutrientType.Iron, this.showRoundedDv);
  }

  get ironDv() {
    return this.getNutrientDvDelegate(NutrientType.Iron, this.showRoundedDv);
  }

  get vitaminD() {
    return this.getNutrientDelegate(NutrientType.VitaminD, this.showRoundedDv);
  }

  get vitaminDDv() {
    return this.getNutrientDvDelegate(NutrientType.VitaminD, this.showRoundedDv);
  }

  NutrientType = NutrientType;

  get dVRoundPrecision() {
    return this.showRoundedDv ? 0 : 2;
  }

  get isTrial() {
    return this.$store.getters.getUserDetails.isTrial;
  }

  getNutrientDelegate(nutrientType: NutrientType, showRoundedDv: boolean) {
    return showRoundedDv
      ? round(this.nutrition.getRoundedValue(nutrientType), 2)
      : round(this.nutrition.getExactValue(nutrientType), 2);
  }

  getNutrientDvDelegate(nutrientType: NutrientType, showRoundedDv: boolean) {
    return showRoundedDv
      ? round(this.nutrition.getRoundedDailyValue(nutrientType), 0)
      : round(this.nutrition.getExactDailyValue(nutrientType), 2);
  }

  get shouldRenderGramsServingSize() {
    return (
      this.nutrition.displayServingQuantityAndMeasure.item2.toLowerCase() === "g"
      && (this.nutrition.servingUnitOfMeasurementOverride == null
        || (this.nutrition.servingUnitOfMeasurementOverride != null
          && this.nutrition.servingUnitOfMeasurementOverride.toLowerCase() === this.nutrition.servingUnitOfMeasurement.toLowerCase()))
      && this.nutrition.servingQuantityInUnitOfMeasurementOverride === null
    );
  }

}
